import { useState } from "react";
import { authClient } from "../lib/auth-client";

const SCOPE_LABELS: Record<string, string> = {
  openid: "Verify your identity",
  profile: "Your name and profile",
  email: "Your email address",
  offline_access: "Stay connected in the background",
};

/**
 * OAuth consent screen. The OAuth Provider plugin redirects here (after login)
 * when a client — e.g. the Claude connector — requests access. Approving grants
 * the client an access token scoped to this user.
 */
export function ConsentPage() {
  const params = new URLSearchParams(window.location.search);
  const clientName = params.get("client_name") || params.get("client_id") || "An application";
  const scopes = (params.get("scope") || "").split(/[\s,]+/).filter(Boolean);
  const [busy, setBusy] = useState<"accept" | "deny" | null>(null);
  const [err, setErr] = useState<string | null>(null);

  async function decide(accept: boolean) {
    setBusy(accept ? "accept" : "deny");
    setErr(null);
    try {
      const { data, error } = await authClient.oauth2.consent({ accept });
      if (error) throw new Error(error.message || "Consent failed");
      window.location.href = data?.url || "/app/plan";
    } catch (e) {
      setErr((e as Error).message);
      setBusy(null);
    }
  }

  return (
    <div className="auth-wrap">
      <div className="auth-card">
        <div className="auth-brand">
          Founder<span>Deck</span>
        </div>
        <div className="auth-sub" style={{ marginBottom: 16 }}>
          <b>{clientName}</b> wants to connect to your FounderDeck.
        </div>

        <div style={{ textAlign: "left", marginBottom: 18 }}>
          <div style={{ fontSize: 12, color: "var(--dim)", marginBottom: 8 }}>It will be able to:</div>
          {(scopes.length ? scopes : ["profile"]).map((s) => (
            <div key={s} style={{ fontSize: 13, padding: "3px 0" }}>
              · {SCOPE_LABELS[s] ?? s}
            </div>
          ))}
          <div style={{ fontSize: 13, padding: "3px 0" }}>· Read and manage your tasks, notes, and jots</div>
        </div>

        {err && <div className="form-err">{err}</div>}

        <button className="btn" disabled={busy !== null} onClick={() => decide(true)}>
          {busy === "accept" ? "Connecting…" : "Approve"}
        </button>
        <button
          className="btn-ghost"
          style={{ marginTop: 8 }}
          disabled={busy !== null}
          onClick={() => decide(false)}
        >
          Deny
        </button>
      </div>
    </div>
  );
}
